import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const messages = {
    'en': {
        ...(require('../lang/en').message),
    },
    'cn': {
        ...(require('../lang/cn').message),
    },
};

// https://kazupon.github.io/vue-i18n/guide/fallback.html#implicit-fallback-using-locales
export const i18n = new VueI18n({
    // silentFallbackWarn: true,
    // formatFallbackMessages: true,
    silentTranslationWarn: true,
    fallbackLocale: 'en',
    locale: localStorage.getItem('lang') || 'cn',
    messages,
});